// src/pages/PartnerManagement.jsx
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Truck, Users, Store } from 'lucide-react';
import useAuth from '../hooks/useAuth';

const PartnerManagement = () => {
    const navigate = useNavigate();
    const { isAdmin, isManager, isCommercial } = useAuth();

    // Déterminer quels types de partenaires sont accessibles selon le rôle
    const canAccessSuppliers = isAdmin || isManager;
    const canAccessDistributors = isAdmin || isManager;
    const canAccessRetailers = isAdmin || isManager || isCommercial;

    const partnerTypes = [
        {
            id: 'suppliers',
            title: 'Fournisseurs',
            description: 'Gérer les fournisseurs qui approvisionnent vos produits',
            icon: <Truck size={36} />,
            color: 'bg-info bg-opacity-10 text-info',
            path: '/suppliers',
            access: canAccessSuppliers
        },
        {
            id: 'distributors',
            title: 'Distributeurs',
            description: 'Gérer les clients distributeurs avec compte utilisateur',
            icon: <Users size={36} />,
            color: 'bg-success bg-opacity-10 text-success',
            path: '/distributors',
            access: canAccessDistributors
        },
        {
            id: 'retailers',
            title: 'Détaillants',
            description: 'Gérer les clients particuliers suivis par les commerciaux',
            icon: <Store size={36} />,
            color: 'bg-primary bg-opacity-10 text-primary',
            path: '/retailers',
            access: canAccessRetailers
        }
    ];

    // Filtrer les types de partenaires selon les droits d'accès
    const filteredPartnerTypes = partnerTypes.filter(type => type.access);

    return (
        <Container fluid>
            <h1 className="h3 mb-4">Gestion des Partenaires</h1>

            <Row>
                {filteredPartnerTypes.map(type => (
                    <Col md={4} key={type.id} className="mb-4">
                        <Card
                            className="h-100 shadow-sm hover-card"
                            onClick={() => navigate(type.path)}
                            style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                        >
                            <Card.Body className="d-flex flex-column">
                                <div className={`rounded-circle p-3 mb-3 align-self-start ${type.color}`}>
                                    {type.icon}
                                </div>
                                <Card.Title>{type.title}</Card.Title>
                                <Card.Text className="text-muted">
                                    {type.description}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default PartnerManagement;